var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ab-checkbox",on:{"click":_vm.toggle}},[_c('input',{staticClass:"ab-checkbox__input",class:{
      'ab-checkbox--error': _vm.error,
      'ab-checkbox--readonly': _vm.readOnly,
    },attrs:{"type":"checkbox","required":_vm.required,"disabled":_vm.disabled,"aria-disabled":_vm.disabled},domProps:{"checked":_vm.value}}),_vm._v(" "),(_vm.hasSlot)?_c('label',{staticClass:"ab-checkbox__label"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }